/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { drawStadium } from './StadiumCanvas';

export default function ThirdStats({ embed = false } = {}) {
  const matches = useSelector((state) => state.gameStats.matches);
  const mtc = useSelector((state) => state.gameStats.selectedMatch);
  const match = matches && matches[mtc];
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (!match) return;

    drawStadium(ctx, match.stadium);
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    const thirds = Array.isArray(match.thirds) ? match.thirds : [0, 0, 0];
    const total = thirds.reduce((acc, val) => acc + Number(val || 0), 0) || 1;
    const pct = thirds.map((val) => Math.round((Number(val || 0) / total) * 100));

    // Tint each territory band without adding a second block of labels below
    // the map. The color bands and the percentages keep the map readable while
    // leaving the overview compact.
    ctx.fillStyle = 'rgba(248, 113, 113, 0.22)';
    ctx.fillRect(0, 0, 166, 250);
    ctx.fillStyle = 'rgba(148, 163, 184, 0.15)';
    ctx.fillRect(166, 0, 168, 250);
    ctx.fillStyle = 'rgba(96, 165, 250, 0.22)';
    ctx.fillRect(334, 0, 166, 250);

    const centers = [83, 250, 417];
    ctx.strokeStyle = 'rgba(226, 232, 240, 0.28)';
    ctx.lineWidth = 1;
    [166, 334].forEach((x) => {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, 250);
      ctx.stroke();
    });

    ctx.font = '45px "Open Sans", Arial, sans-serif';
    ctx.lineWidth = 6;
    ctx.strokeStyle = 'rgba(2, 6, 23, 0.45)';
    ctx.fillStyle = '#F8FAFC';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    pct.forEach((value, i) => {
      const text = `${value}%`;
      ctx.strokeText(text, centers[i], 132);
      ctx.fillText(text, centers[i], 132);
    });
  }, [match]);

  return (
    <div className={embed ? 'gs-thirds-embed' : 'gs-thirds-wrapper'}>
      <canvas
        ref={canvasRef}
        width={500}
        height={250}
        aria-label="Territory control map"
      />
    </div>
  );
}
